
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { AsyncMultiSelect } from '../custom-form/custom-async-multi-select.component';
import DateRange from '../custom-form/custom-date-range-component';
import ButtonIcon from '../../button';
import Translation from '../translation/translation.component';
export const FilterGenerateReport = (props,{customClassName}) => {
    console.log("Rendering FilterGenerateReport with props:", props);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate ] = useState(null);


    const handleOnDateChange = (dates) => {
        const [start, end] = dates;
        
        setStartDate(start)
        setEndDate(end)

        if(props.onDateRangeChange) {
            props.onDateRangeChange(`${start} - ${end}`)
        }
      };

    return (
        <div className="filter-wrapper filter-multi-select-wrapper">
                <div className={`component-container legend-center second-col-container ${customClassName}`}>                    
                    <div className="filter-button-container mt-4">
                         <AsyncMultiSelect
                            label={<Translation translationKey={'country'} />}
                            placeholder="Search..."
                            onSelectionChange={props.onFirstMultipleSelect}                           
                            fetchOptions={props.handleFirstOptionListLoadMore}
                        />
                        <AsyncMultiSelect
                            key={props.vendorResetKey}
                            label={<Translation translationKey={'vendor_capital'} />}
                            placeholder="Search..."
                            onSelectionChange={props.onSecondMultipleSelect}
                            fetchOptions={props.handleSecondOptionListLoadMore}
                            isDisabled={props.secondOptionListIsDisabled}
                        />
                        <AsyncMultiSelect
                            key={props.accountResetKey}
                            label={<Translation translationKey={'account_number'} />}
                            placeholder="Search..."
                            onSelectionChange={props.onThirdMultipleSelect}
                            fetchOptions={props.handleThirdOptionListLoadMore}
                            isDisabled={props.thirdOptionListIsDisabled}
                        />
                         <AsyncMultiSelect
                            key={props.invoiceStatusKey}
                            label={<Translation translationKey={'invoice_status'} />}
                            placeholder="Search..."
                            onSelectionChange={props.onFourthMultipleSelect}
                            fetchOptions={props.handleFourthOptionListLoadMore}
                            isDisabled={props.fourthOptionListIsDisabled}
                        />
                         <DateRange
                            dateOnly={true}
                            label={<Translation translationKey={'invoice_approve_date'} />}
                            placeholder={`Select Date Range`}
                            startDate={startDate}
                            endDate={endDate}
                            dateSelected={null}
                            onChange={handleOnDateChange}
                            dateRangeWrapperClass="filter-multi-date-range"
                            isDisable={props.dateRangeIsDisabled}
                        />
                    </div>
                     <div className="ms-auto mt-3">
                            <ButtonIcon onClick={()=>{}} customClassName="header-option-list header-filter-button" labelName="Generate AP Report" />
                      </div>
                </div>
            </div>
    );
};